export default "__VITE_ASSET__YWMR8BS9__"